<template>
  <q-form ref="editForm">
    <!-- 화기작업 상세정보 -->
    <c-card title="LBL0000221" class="cardClassDetailForm no-margin">
      <template slot="card-button">
        <q-chip dense>
          작업인원수
          <q-avatar
            color="blue"
            text-color="white"
            class="workpermit-worker-info"
          >
            {{
              workPermit.workers && workPermit.workers.length > 0
                ? workPermit.workers.length
                : 0
            }}
          </q-avatar>
        </q-chip>
      </template>
      <template slot="card-detail">
        <div class="col-xs-12 col-sm-12 col-md-5 col-lg-5">
          <!-- 작업개요 -->
          <c-text
            :required="true"
            :disabled="!isWriting"
            :editable="editable"
            label="작업명"
            name="workSummary"
            v-model="workPermit.workSummary"
          >
          </c-text>
        </div>
        <div class="col-xs-6 col-sm-4 col-md-2 col-lg-2">
          <!-- 작업업체 -->
          <c-vendor
            :disabled="!isWriting || isVendor"
            :editable="editable"
            label="LBL0000224"
            name="vendorCd"
            v-model="workPermit.vendorCd"
            @dataChange="vendorChange"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-5 col-lg-5">
          <!-- 작업장소 -->
          <c-location
            isMultiple
            isMapShowing
            :disabled="!isWriting"
            :editable="editable"
            :data="workPermit"
            etcInput="locationEtc"
            label="LBL0000225"
            name="workLocation"
            v-model="workPermit.workLocation"
            @dataChange="setLocationInfo"
          >
          </c-location>
        </div>
        <div class="col-xs-6 col-sm-4 col-md-2 col-lg-2">
          <!-- 단위공정 -->
          <c-process
            :disabled="!isWriting"
            :editable="editable"
            label="공정"
            name="processCd"
            v-model="workPermit.processCd"
          >
          </c-process>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-5 col-lg-5">
          <!-- 관련 설비 -->
          <c-equip
            isMultiple
            :disabled="!isWriting"
            :editable="editable"
            :plantCd="workPermit.plantCd"
            :processCd="workPermit.processCd"
            label="LBL0000227"
            name="equipmentCd"
            v-model="workPermit.equipmentCd"
            @dataChange="equipChange"
          >
          </c-equip>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
          <!-- 특별요구사항 -->
          <c-textarea
            :disabled="!isWriting"
            :editable="editable"
            :rows="1"
            label="LBL0000230"
            name="specialRequirements"
            v-model="workPermit.specialRequirements"
          >
          </c-textarea>
        </div>
        <div class="col-xs-6 col-sm-4 col-md-2 col-lg-2" v-if="isVendor">
          <!-- 담당자 -->
          <c-field
            :required="true"
            :disabled="!isWriting"
            :editable="editable"
            :data="workPermit"
            :plantCd="workPermit.plantCd"
            deptValue="workManagerDeptCd"
            type="dept_user"
            userType="user"
            label="허가서담당자(금호티앤엘)"
            beforeText=""
            name="workManagerId"
            v-model="workPermit.workManagerId"
          />
        </div>
        <div class="col-xs-6 col-sm-4 col-md-2 col-lg-2" v-if="!isVendor">
          <!-- 신청인 -->
          <c-text
            :disabled="true"
            :editable="editable"
            :label="requestLabel"
            name="request"
            v-model="request"
          >
          </c-text>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
          <!-- 보호구 -->
          <c-checkbox
            :disabled="!isWriting"
            :editable="editable"
            codeGroupCd="SOP_PROTECTIVE_GEAR_CD"
            :isObject="true"
            valueText="sopProtectiveGearName"
            valueKey="sopProtectiveGearCd"
            label="LBL0000231"
            name="protectiveGears"
            v-model="workPermit.protectiveGears"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
          <!-- 중장비 -->
          <c-checkbox
            :disabled="!isWriting"
            :editable="editable"
            codeGroupCd="SOP_HEAVY_EQUIPMENT_CD"
            :isObject="true"
            valueText="sopHeavyEquipmentName"
            valueKey="sopHeavyEquipmentCd"
            label="중장비"
            name="heavyEquipments"
            v-model="workPermit.heavyEquipments"
          />
        </div>
      </template>
    </c-card>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
        <!-- 안전조치 요구사항 -->
        <c-table
          title="LBL0000232"
          :columns="grid.columns"
          :gridHeight="grid.height"
          :data="workPermit.checkResults"
          :filtering="false"
          :columnSetting="false"
          :usePaging="false"
          :editable="editable && isWriting"
          :contentsField="contentsField"
          @table-data-change="tableDataChange"
        >
        </c-table>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-9 col-lg-9">
        <div class="row">
          <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4" v-if="!isVendor">
            <!-- 신청정보 -->
            <c-card title="신청정보" class="cardClassDetailForm no-margin">
              <template slot="card-detail">
                <div class="col-6">
                  <!-- 발급 -->
                  <c-field
                    :required="!isVendor"
                    :disabled="!isWriting"
                    :editable="editable"
                    :data="workPermit"
                    deptValue="issuedDeptCd"
                    type="dept_user"
                    label="담당자 검토"
                    name="issuedUserId"
                    v-model="workPermit.issuedUserId"
                  />
                </div>
                <div class="col-6">
                  <!-- 승인 -->
                  <c-field
                    :required="!isVendor"
                    :disabled="!isWriting"
                    :editable="editable"
                    :data="workPermit"
                    deptValue="approvalDeptCd"
                    type="dept_user"
                    label="팀장 승인"
                    name="approvalUserId"
                    v-model="workPermit.approvalUserId"
                  />
                </div>
                <div class="col-12">
                  <c-textarea
                    :disabled="!isWriting"
                    :editable="editable"
                    :rows="1"
                    label="작업부서(팀)장 전달사항"
                    name="workDeptHeadDeliveryMessage"
                    v-model="workPermit.workDeptHeadDeliveryMessage"
                  >
                  </c-textarea>
                </div>
              </template>
            </c-card>
          </div>
          <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4" v-if="!isVendor">
            <!-- 승인정보 -->
            <c-card title="승인정보" class="cardClassDetailForm no-margin">
              <template slot="card-detail">
                <!-- 협조자-1 -->
                <div class="col-6">
                  <c-field
                    :required="!isVendor"
                    :disabled="!isWriting"
                    :editable="editable"
                    :data="workPermit"
                    deptValue="relationCooperation1DeptCd"
                    type="dept_user"
                    label="담당자 검토"
                    name="relationCooperation1UserId"
                    v-model="workPermit.relationCooperation1UserId"
                  />
                </div>
                <div class="col-6">
                  <!-- 협조자-2 -->
                  <c-field
                    :required="!isVendor"
                    :disabled="!isWriting"
                    :editable="editable"
                    :data="workPermit"
                    deptValue="relationCooperation2DeptCd"
                    type="dept_user"
                    label="팀장 승인"
                    name="relationCooperation2UserId"
                    v-model="workPermit.relationCooperation2UserId"
                  />
                </div>
                <div class="col-12">
                  <c-textarea
                    :disabled="!isWriting"
                    :editable="editable"
                    :rows="1"
                    label="승인부서(팀)장 전달사항"
                    name="approvalDeptHeadDeliveryMessage"
                    v-model="workPermit.approvalDeptHeadDeliveryMessage"
                  >
                  </c-textarea>
                </div>
              </template>
            </c-card>
          </div>
          <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4" v-if="!isVendor">
            <!-- 안전조치확인 정보 -->
            <c-card title="LBL0000247" class="cardClassDetailForm no-margin">
              <template slot="card-button">
                <q-btn-group outline>
                  <c-btn
                    v-if="isWriting"
                    label="신청/승인 정보 불러오기"
                    color="teal-custom"
                    @btnClicked="getUserSetting"
                    icon="download"
                  />
                </q-btn-group>
              </template>
              <template slot="card-detail">
                <div class="col-6">
                  <!-- 책임자 -->
                  <c-field
                    :disabled="!isWriting"
                    :editable="editable"
                    :data="workPermit"
                    deptValue="maintenanceDeptCheckDeptCd"
                    type="dept_user"
                    label="신청부서 확인"
                    name="maintenanceDeptCheckUserId"
                    v-model="workPermit.maintenanceDeptCheckUserId"
                  />
                </div>
                <div class="col-6">
                  <!-- 입회자 -->
                  <c-field
                    :disabled="!isWriting"
                    :editable="editable"
                    :data="workPermit"
                    deptValue="maintenanceDeptEntryDeptCd"
                    type="dept_user"
                    label="승인부서 확인"
                    name="maintenanceDeptEntryUserId"
                    v-model="workPermit.maintenanceDeptEntryUserId"
                  />
                </div>
                <div class="col-12">
                  <!-- 입회자 -->
                  <c-field
                    :disabled="!isWriting"
                    :editable="editable"
                    :data="workPermit"
                    deptValue="maintenanceDeptConfirmDeptCd"
                    type="dept_user"
                    label="확인부서"
                    name="maintenanceDeptConfirmUserId"
                    v-model="workPermit.maintenanceDeptConfirmUserId"
                  />
                </div>
              </template>
            </c-card>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <!-- 가스농도 측정 -->
            <c-table
              ref="gasTable"
              title="LBL0000236"
              :columns="grid2.columns"
              :gridHeight="grid2.height"
              :data="workPermit.gases"
              :filtering="false"
              :columnSetting="false"
              :usePaging="false"
              :editable="editable && isWriting"
              selection="multiple"
              rowKey="sopGasCheckId"
            >
              <template slot="table-button">
                <q-btn-group outline>
                  <!-- 추가 -->
                  <c-btn
                    v-if="editable && isWriting"
                    label="LBL0000253"
                    icon="add"
                    :showLoading="false"
                    @btnClicked="addGas"
                  />
                  <!-- 제외 -->
                  <c-btn
                    v-if="editable && isWriting"
                    label="LBL0000275"
                    icon="remove"
                    :showLoading="false"
                    @btnClicked="removeGas"
                  />
                </q-btn-group>
              </template>
            </c-table>
          </div>
        </div>
      </div>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </q-form>
</template>

<script>
import { uid } from "quasar";
import eventBus from "@/js/eventBus";
import selectConfig from "@/js/selectConfig";
export default {
  name: "swp-fire",
  props: {
    workPermit: {
      type: Object,
      default: function () {
        return {
          sopWorkPermitId: "", // 작업허가서 일련번호
          plantCd: "", // 사업장 코드
          sopName: "", // 작업명
          mdmSopId: "", // 안전작업 표준 일련번호_SOP에서 불러와서 관련 정보 표시후 수정
          permitNo: "", // 허가번호_(YYYYMMDD-01)
          swpStepCd: "", // 진행단계 코드
          applicationDeptCd: "", // 신청인 부서코드
          applicationDeptName: "",
          applicationUserId: "", // 신청인 ID
          applicationUserName: "",
          permitTypeCd: "", // 허가서 구분_화기/일반
          permitDate: "", // 허가일
          workStartTime: "", // 작업시작시간
          workEndTime: "", // 작업종료시간
          workTime: [], // 작업시간
          processCd: "", // 작업공정
          workLocation: "", // 작업장소
          locationEtc: "", // 기타장소
          equipmentCd: "", // 설비번호_설비마스터
          workSummary: "", // 작업개요
          specialRequirements: "", // 특별요구사항
          maintenanceDeptCheckUserId: "", // 정비부서 책임자 - 안전조치확인
          maintenanceDeptEntryUserId: "", // 정비부서 입회자 - 안전조치확인
          maintenanceDeptConfirmUserId: "", // 정비부서 확인부서 - 안전조치확인
          workCompleteTime: "", // 작업완료시간
          workCompleteEntryUserId: "", // 작업완료 입회자/확인자
          workCompleteWorkUserId: "", // 작업완료 작업자
          issuedDeptCd: "", // 발급자 부서코드
          issuedUserId: "", // 발급자 ID
          approvalDeptCd: "", // 승인자 부서코드
          approvalUserId: "", // 승인자 ID
          workDeptHeadDeliveryMessage: "", // 작업부서(팀)장 전달사항
          relationCooperation1DeptCd: "", // 관련부서 협조자1 부서코드
          relationCooperation1UserId: "", // 관련부서 협조자1 ID
          relationCooperation2DeptCd: "", // 관련부서 협조자2 부서코드
          relationCooperation2UserId: "", // 관련부서 협조자2 ID
          approvalDeptHeadDeliveryMessage: "", // 승인부서(팀)장 전달사항
          vendorCd: "", // 작업업체 코드
          overWorkFlag: "", // 연장작업 여부
          vendorFlag: 0, // 업체작성여부
          assessWriteUserId: "", // 작업위험성평가_작성자 ID
          assessApprovalUserId: "", // 작업위험성평가_승인자 ID
          sopConstructionId: "",
          regUserId: "", // 등록자 ID
          chgUserId: "", // 수정자 ID
          supWorks: [],
          deleteSupWorks: [],
          checkResults: [],
          deleteCheckResults: [],
          gases: [],
          gasChecks: [], // 저장용
          deleteGasChecks: [],
          deleteGasCheckVals: [],
          maps: [],
          deleteMaps: [],
          workers: [],
          deleteWorkers: [],
          assessments: [],
          deleteAssessments: [],
          overs: [],
          deleteOvers: [],
          protectiveGears: [],
          deleteProtectiveGears: [],
          heavyEquipments: [],
          deleteHeavyEquipments: [],
          lotos: [],
          deleteLotos: [],
          locationInfos: [],
        };
      },
    },
    isOld: {
      type: Boolean,
      default: false,
    },
    isWriting: {
      type: Boolean,
      default: false,
    },
    saveCall: {
      type: Object,
      default: function () {
        return {
          saveCallData: "",
        };
      },
    },
    isVendor: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      grid: {
        columns: [],
        data: [],
        height: "580px",
      },
      grid2: {
        columns: [],
        height: "382px",
      },
      useGasItems: [],
      editable: true,
      listCheckItemUrl: "",
      listGasItemUrl: "",
      popupOptions: {
        target: null,
        title: "",
        visible: false,
        width: "90%",
        top: "10px",
        param: {},
        closeCallback: null,
      },
    };
  },
  computed: {
    request() {
      return this.isVendorReqeust
        ? this.workPermit.applicationDeptName
        : this.workPermit.applicationDeptName +
            " / " +
            this.workPermit.applicationUserName;
    },
    requestLabel() {
      return this.isVendor ? "작성업체" : "작성자";
    },
    isVendorReqeust() {
      return this.workPermit.vendorFlag > 0;
    },
  },
  watch: {
    "workPermit.plantCd"() {
      this.$set(this.workPermit, "checkResults", []);
      this.$set(this.workPermit, "gases", []);
      this.getCheckItemList();
      this.getGasItemList();
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    eventBus.$on("vaildForm", (type) => {
      if (this.$refs["editForm"]) {
        this.$refs["editForm"].validate().then((_result) => {
          this.$emit("validResult", _result, type);
        });
      }
    });
    this.init();
  },
  beforeDestroy() {},
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listCheckItemUrl = selectConfig.sop.swp.workChekItem.list.url;
      this.listGasItemUrl = selectConfig.sop.swp.gas.list.url;
      // code setting
      // list setting
      this.getCheckItemList();
      this.getGasItemList();
    },
    getCheckItemList() {
      /**
       * default 값을 조회
       *
       * 초기인 경우 workPermit.checkResults에 값을 그대로 적용
       * 작성중 단계인 경우 default 값에 새로운 항목이 있을시에 workPermit.checkResults에 추가하여 입력을 받을 수 있도록 조치
       * 승인완료, 연장, 취소, 작업완료인 경우 저장된 데이터를 그대로 표시하며 이 경우 default값을 조회하지 않도록 조치
       */
      this.grid.columns = [
        // 항목
        {
          name: "checkItemName",
          field: "checkItemName",
          label: "LBL0000233",
          align: "left",
          sortable: true,
        },
        // 필요
        {
          name: "necessaryFlag",
          field: "necessaryFlag",
          label: "LBL0000234",
          align: "center",
          sortable: false,
          type: "check",
          true: "Y",
          false: "N",
          value: "N",
          setHeader: true,
        },
        // 확인
        {
          name: "confirmFlag",
          field: "confirmFlag",
          label: "LBL0000235",
          align: "center",
          sortable: false,
          type: "check",
          disableTarget: "necessaryFlag",
          disableCon: "Y",
          true: "Y",
          false: "N",
          value: "N",
          setHeader: true,
        },
      ];
      if (!this.workPermit.plantCd) return;
      if (!this.workPermit.checkResults) this.workPermit.checkResults = [];
      if (!this.isOld || this.workPermit.swpStepCd === "SS00000001") {
        this.$http.url = this.listCheckItemUrl;
        this.$http.type = "GET";
        this.$http.param = {
          plantCd: this.workPermit.plantCd,
          sopWorkTypeCd: "SWT0000005",
          useFlag: "Y",
        };
        this.$http.request((_result) => {
          if (
            !this.isOld &&
            (!this.workPermit.checkResults ||
              this.workPermit.checkResults.length === 0)
          ) {
            // 최초인 경우 조치항목을 가지고 있지 않음으로 해당 값을 표시
            this.$_.forEach(_result.data, (item) => {
              this.workPermit.checkResults.push({
                sopWorkPermitId: "", // 작업허가서 일련번호
                supplementWorkTypeCd: "", // 보충작업구분
                sopCheckItemId: item.sopCheckItemId, // 점검항목 일련번호
                checkItemName: item.checkItemName, // 점검항목명
                sopCheckItemKindCd: item.sopCheckItemKindCd, // 체크항목 종류
                necessaryFlag: "N", // 필요
                confirmFlag: "N", // 확인
                confirmUserId: "", // 확인자
                confirmUserName: "", // 확인자명
                regUserId: this.$store.getters.user.userId, // 등록자 ID
                chgUserId: "", // 수정자 ID
                editFlag: "C",
              });
            });
          } else {
            this.$_.forEach(_result.data, (item) => {
              if (
                this.$_.findIndex(this.workPermit.checkResults, {
                  sopCheckItemId: item.sopCheckItemId,
                }) === -1
              ) {
                this.workPermit.checkResults.push({
                  sopWorkPermitId: this.workPermit.sopWorkPermitId, // 작업허가서 일련번호
                  supplementWorkTypeCd: "", // 보충작업구분
                  sopCheckItemId: item.sopCheckItemId, // 점검항목 일련번호
                  checkItemName: item.checkItemName, // 점검항목명
                  sopCheckItemKindCd: item.sopCheckItemKindCd, // 체크항목 종류
                  necessaryFlag: "N", // 필요
                  confirmFlag: "N", // 확인
                  confirmUserId: "", // 확인자
                  confirmUserName: "", // 확인자명
                  regUserId: this.$store.getters.user.userId, // 등록자 ID
                  chgUserId: "", // 수정자 ID
                  editFlag: "C",
                });
              }
            });
          }

          // 확인자
          if (
            this.$_.findIndex(_result.data, {
              sopCheckItemKindCd: "SCIK000005",
            }) > -1 ||
            this.$_.findIndex(this.workPermit.checkResults, {
              sopCheckItemKindCd: "SCIK000005",
            }) > -1
          ) {
            this.grid.columns.push({
              name: "confirmUserName",
              field: "confirmUserName",
              label: "LBL0000240",
              align: "center",
              sortable: true,
              type: !this.isVendor ? "user" : "userVendor",
              userId: "confirmUserId",
              disableTarget: "necessaryFlag",
              disableCon: "Y",
            });
          }
        });
        // 확인자
      } else {
        if (
          this.$_.findIndex(this.workPermit.checkResults, {
            sopCheckItemKindCd: "SCIK000005",
          }) > -1
        ) {
          this.grid.columns.push({
            name: "confirmUserName",
            field: "confirmUserName",
            label: "LBL0000240",
            align: "center",
            sortable: true,
            type: !this.isVendor ? "user" : "userVendor",
            userId: "confirmUserId",
            disableTarget: "necessaryFlag",
            disableCon: "Y",
          });
        }
      }
    },
    getGasItemList() {
      let columns = [];
      let defaultColumns = [
        // 점검시간
        {
          name: "checkTime",
          field: "checkTime",
          label: "측정시간",
          align: "center",
          type: "datetime",
          minuteStep: 10,
          sortable: false,
          style: "width:120px",
        },
        // // 점검기기
        // {
        //   name: 'gasCheckMachine',
        //   field: 'gasCheckMachine',
        //   label: 'LBL0000238',
        //   align: 'center',
        //   sortable: false,
        //   type: 'text',
        //   value: '',
        //   setHeader: true,
        //   style: 'width:15%',
        // },
        // 측정자
        {
          name: "gasCheckUserName",
          field: "gasCheckUserName",
          label: "측정자",
          align: "center",
          sortable: false,
          type: !this.isVendor ? "user" : "userVendor",
          userId: "gasCheckUserId",
          value: "",
          setHeader: true,
          style: "width:150px",
        },
        // // 확인자
        // {
        //   name: 'gasConfirmUserName',
        //   field: 'gasConfirmUserName',
        //   label: 'LBL0000240',
        //   align: 'center',
        //   sortable: false,
        //   type: !this.isVendor ? 'user' : 'userVendor',
        //   userId: 'gasConfirmUserId',
        //   value: '',
        //   setHeader: true,
        //   style: 'width:10%',
        // },
      ];

      this.$http.url = this.listGasItemUrl;
      this.$http.type = "GET";
      this.$http.param = {
        plantCd: this.workPermit.plantCd,
        // sopWorkTypeCd: 'SWT0000005',
      };
      this.$http.request((_result) => {
        this.useGasItems = [];
        if (this.workPermit.gases && this.workPermit.gases.length > 0) {
          let pushData = [];
          this.$_.forEach(this.workPermit.gases, (gas) => {
            for (let gasValue in gas) {
              let idx = this.$_.findIndex(_result.data, { sopGasId: gasValue });
              let idx2 = this.$_.findIndex(pushData, { sopGasId: gasValue });
              /**
               * idx의 경우 기본적으로 존재하는지 여부를 판단하지만
               *            예전 입력된 값 중 useFlag N처리된 값이 있는 경우는 허용
               */
              if (idx > -1 && gas[gasValue] !== "-" && idx2 === -1) {
                this.$set(_result.data[idx], "me");
                pushData.push(_result.data[idx]);
              }
            }
          });
          if (pushData && pushData.length > 0) {
            this.$_.forEach(pushData, (item) => {
              this.useGasItems.push(item);
              columns.push({
                // 가스 헤더 적용 로직 추가 필요
                name: item.sopGasId + "_p",
                field: item.sopGasId + "_p",
                label: item.gasName,
                align: "center",
                sortable: false,
                child: [
                  {
                    name: item.sopGasId,
                    field: item.sopGasId,
                    label: item.safetyStandards,
                    align: "center",
                    type: "text",
                    sortable: false,
                    style: "width:130px",
                  },
                ],
              });
            });
          }
        } else {
          let useYList = this.$_.filter(_result.data, (item) => {
            return (
              item.useFlag === "Y" &&
              this.$_.findIndex(item.workTypes, {
                sopWorkTypeCd: "SWT0000005",
              }) > -1
            );
          });
          this.$_.forEach(useYList, (gas) => {
            this.useGasItems.push(gas);
            columns.push({
              // 가스 헤더 적용 로직 추가 필요
              name: gas.sopGasId + "_p",
              field: gas.sopGasId + "_p",
              label: gas.gasName,
              align: "center",
              sortable: false,
              child: [
                {
                  name: gas.sopGasId,
                  field: gas.sopGasId,
                  label: gas.safetyStandards,
                  align: "center",
                  type: "text",
                  sortable: false,
                  style: "width:130px",
                },
              ],
            });
          });
        }

        this.grid2.columns = this.$_.concat(columns, defaultColumns);
      });
    },
    addGas() {
      let pushData = {
        sopGasCheckId: uid(), // 가스농도측정번호
        sopWorkPermitId: this.workPermit.sopWorkPermitId, // 작업허가서 일련번호
        supplementWorkTypeCd: "", // 보충작업구분
        checkTime: "", // 점검시간
        gasCheckMachine: "", // 점검기기명
        gasCheckUserName: "",
        gasCheckUserId: "", // 점검자
        gasConfirmUserName: "",
        gasConfirmUserId: "", // 확인자(입회자)
        regUserId: this.$store.getters.user.userId, // 등록자 ID
        chgUserId: "", // 수정자 ID
        editFlag: "C",
      };
      this.$_.forEach(this.useGasItems, (gas) => {
        this.$set(pushData, gas.sopGasId, "0");
      });

      this.workPermit.gases.push(pushData);
    },
    removeGas() {
      let selectData = this.$refs["gasTable"].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit("ALERT", {
          title: "LBLGUIDE", // 안내
          message: "MSG0000103", // 제외할 행을 지정하세요.
          type: "warning", // success / info / warning / error
        });
      } else {
        if (!this.workPermit.deleteGasChecks)
          this.workPermit.deleteGasChecks = [];
        if (!this.workPermit.deleteGasCheckVals)
          this.workPermit.deleteGasCheckVals = [];
        this.$_.forEach(selectData, (item) => {
          if (
            this.$_.findIndex(this.workPermit.deleteGasChecks, {
              sopGasCheckId: item.sopGasCheckId,
            }) === -1 &&
            item.editFlag !== "C"
          ) {
            this.workPermit.deleteGasChecks.push(item);
            this.$_.forEach(this.useGasItems, (gas) => {
              this.workPermit.deleteGasCheckVals.push({
                sopGasCheckId: item.sopGasCheckId,
                sopGasId: gas.sopGasId,
              });
            });
          }
          this.workPermit.gases = this.$_.reject(this.workPermit.gases, item);
        });
        this.$refs["gasTable"].$refs["compo-table"].clearSelection();
      }
    },
    vendorChange(vendorCd, beforeVendorCd) {
      if (this.workPermit.workers && this.workPermit.workers.length > 0) {
        window.getApp.$emit("CONFIRM", {
          title: "LBLCONFIRM",
          message:
            "해당 작업업체별로 지정된 작업자 정보들이 제외됩니다. 진행하시겠습니까?",
          type: "info", // success / info / warning / error
          confirmCallback: () => {
            if (!this.workPermit.deleteWorkers) {
              this.workPermit.deleteWorkers = [];
            }
            this.$_.forEach(
              this.$_.filter(this.workPermit.workers, {
                vendorCd: beforeVendorCd,
              }),
              (item) => {
                if (
                  this.$_.findIndex(this.workPermit.deleteWorkers, {
                    sopWorkerId: item.sopWorkerId,
                  }) === -1
                ) {
                  this.workPermit.deleteWorkers.push(item);
                }
              },
            );
            this.workPermit.workers = this.$_.reject(this.workPermit.workers, {
              vendorCd: beforeVendorCd,
            });
          },
          cancelCallback: () => {
            this.$set(this.workPermit, "vendorCd", beforeVendorCd);
          },
        });
      }
    },
    contentsField(props, col) {
      /**
       * 안전조치사항 항목에서 항목 입력 타입이 '테이블_점검자' 인 경우 테이블에 표시
       * 단, 예전에 '테이블_점검자'였으며 그럼으로 인해 데이터가 저장이 된적이 있는 경우 컴포넌트 표시
       */
      let returnVal = true;
      if (col.name === "confirmUserName") {
        returnVal =
          props.row["sopCheckItemKindCd"] === "SCIK000005" ||
          Boolean(props.row["confirmUserName"]);
      }
      return returnVal;
    },
    tableDataChange(props, col) {
      if (col.name === "necessaryFlag" && props.row[col.name] !== "Y") {
        this.$set(props.row, "confirmFlag", "N");
      }
    },
    setLocationInfo(locations, flag) {
      if (flag === "ADD") {
        /**
         * 추가한 경우
         * locations은 1개 이상
         */
        this.$_.forEach(locations, (location) => {
          if (
            this.$_.findIndex(this.workPermit.locationInfos, {
              mdmLocationId: location.mdmLocationId,
            }) === -1 &&
            Boolean(location.sopMapLocationId)
          ) {
            this.workPermit.locationInfos.push({
              sopMapResultId: uid(),
              sopWorkPermitId: this.workPermit.sopWorkPermitId,
              mdmLocationId: location.mdmLocationId,
              locationName: location.locationName,
              sopMapId: location.sopMapId,
              locationXcoordinate: location.x,
              locationYcoordinate: location.y,
              locationWidth: location.w,
              locationHeight: location.h,
              ratio: location.ratio,
              editFlag: "C",
              regUserId: this.$store.getters.user.userId,
            });
          }
        });
      } else if (flag === "DELETE") {
        /**
         * 삭제한 경우
         * locations이 없을 수 있음
         */
        let deleteDatas = [];
        this.$_.forEach(this.workPermit.locationInfos, (location) => {
          if (
            this.$_.findIndex(locations, {
              mdmLocationId: location.mdmLocationId,
            }) === -1
          ) {
            deleteDatas.push(location);
          }
        });
        if (deleteDatas && deleteDatas.length > 0) {
          this.$_.forEach(deleteDatas, (deleteData) => {
            this.workPermit.locationInfos = this.$_.reject(
              this.workPermit.locationInfos,
              deleteData,
            );
          });
        }
      }

      if (!this.isOld)
        if (
          this.workPermit.locationInfos &&
          this.workPermit.locationInfos.length > 0
        ) {
          this.$set(this.workPermit, "locationMarkFlag", "N");
        } else {
          this.$set(this.workPermit, "locationMarkFlag", "Y");
        }

      // 위치 직접 표시 X
      if (this.workPermit.locationMarkFlag === "N") {
        let resultTypes = [{ sopWorkTypeCd: this.workPermit.permitTypeCd }];
        if (this.workPermit.supWorks && this.workPermit.supWorks.length > 0) {
          this.$_.forEach(this.workPermit.supWorks, (sup) => {
            resultTypes.push({
              sopWorkTypeCd: sup.supplementWorkTypeCd,
            });
          });
        }
        /**
         * 작업장소 정보를 그대로 넣는 경우 이전에 있었던 정보들은
         * deleteMaps에 넣어줘야 새롭게 데이터가 들어가게 됨
         */
        if (this.workPermit.maps && this.workPermit.maps.length > 0) {
          this.$_.forEach(this.workPermit.maps, (map) => {
            if (this.$_.findIndex(this.workPermit.deleteMaps, map) === -1) {
              this.workPermit.deleteMaps.push(map);
            }
          });
        }
        this.$set(
          this.workPermit,
          "maps",
          this.$_.map(this.workPermit.locationInfos, (item) => {
            return this.$_.extend(item, {
              resultTypes: resultTypes,
              editFlag: "C",
            });
          }),
        );
      } else {
        this.$set(this.workPermit, "maps", []);
      }
    },
    getUserSetting() {
      this.popupOptions.title = "신청/승인/안전조치사항 정보 불러오기";
      this.popupOptions.param = {
        type: "single",
      };
      this.popupOptions.target = () =>
        import(`${"@/pages/sop/swp/setting/swpUserSetPop.vue"}`);
      this.popupOptions.width = "30%";
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopupUserSetting;
    },
    closePopupUserSetting(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (data && data.length > 0) {
        this.workPermit.maintenanceDeptCheckUserId =
          data[0].maintenanceDeptCheckUserId;
        this.workPermit.maintenanceDeptEntryUserId =
          data[0].maintenanceDeptEntryUserId;
        this.workPermit.maintenanceDeptConfirmUserId =
          data[0].maintenanceDeptConfirmUserId;
        this.workPermit.issuedDeptCd = data[0].issuedDeptCd;
        this.workPermit.issuedUserId = data[0].issuedUserId;
        this.workPermit.approvalDeptCd = data[0].approvalDeptCd;
        this.workPermit.approvalUserId = data[0].approvalUserId;
        this.workPermit.relationCooperation1DeptCd =
          data[0].relationCooperation1DeptCd;
        this.workPermit.relationCooperation1UserId =
          data[0].relationCooperation1UserId;
        this.workPermit.relationCooperation2DeptCd =
          data[0].relationCooperation2DeptCd;
        this.workPermit.relationCooperation2UserId =
          data[0].relationCooperation2UserId;
      }
    },
    equipChange(equips, oldEquipmentCd, dataFlag) {
      /**
       * 최초 등록하는 경우
       *  - 관련 설비정보가 LOTO로 들어가도록 처리
       *  - 최초에는 관련 설비정보를 변경했을 경우 LOTO정보도 변경하도록 처리
       */
      if (!this.isOld) {
        if (dataFlag === "ADD") {
          this.$_.forEach(equips, (equip) => {
            let idx = this.$_.findIndex(this.workPermit.lotos, {
              equipmentCd: equip.equipmentCd,
            });
            if (idx === -1) {
              this.workPermit.lotos.splice(0, 0, {
                sopLotoId: uid(), // LOTO 일련번호
                sopWorkPermitId: this.workPermit.sopWorkPermitId, // 작업허가서 일련번호
                equipmentCd: equip.equipmentCd,
                equipmentNo: equip.equipmentNo,
                equipmentName: equip.equipmentName,
                equipmentTypeName: equip.equipmentTypeName,
                equipmentLocation: equip.equipmentLocation,
                sopLotoTypeCd: null, // 잠금장치
                regUserId: this.$store.getters.user.userId, // 수정자 ID
                editFlag: "C",
                isPermitInject: true,
              });
            } else {
              // this.$set(this.workPermit.lotos[idx], 'isPermitInject', true)
            }
          });
        } else {
          // DELETE
          let deleteLotos = [];
          this.$_.forEach(
            this.$_.filter(this.workPermit.lotos, { isPermitInject: true }),
            (loto) => {
              let idx = this.$_.findIndex(equips, {
                equipmentCd: loto.equipmentCd,
              });
              if (idx === -1) {
                deleteLotos.push(loto);
              }
            },
          );

          this.$_.forEach(deleteLotos, (deleteLoto) => {
            this.workPermit.lotos = this.$_.reject(
              this.workPermit.lotos,
              deleteLoto,
            );
          });
        }
      }
    },
  },
};
</script>
<style lang="sass">
.gas-item
  padding-top:18px !important
  .q-field__inner
    padding-bottom: 0px !important
  .customText
    padding-bottom: 0px !important
.gas-card-title
  font-size: 15px
  font-weight: 800

.workpermit-worker-info
  margin-left: 0.5em !important
  margin-right: 0 !important
  .q-avatar__content
    font-size: 0.8em
    line-height: 0.8em
</style>
